// extracted by mini-css-extract-plugin
export default {"tabIconButton":"tabs-icon-button_tabIconButton__WiSL+","divider":"tabs-icon-button_divider__-RZ8i"};